<box class="onboarding-container">
    <header>
        <ng-container *ngIf="_commonService.getApplicationMode() == 'RM'; else normalApp">
            <fpx-button *ngIf="_processShellService.getBodNumber()!=2 ||  _processShellService.screenMode == 'rm-view-mode'" className="back" btnType="button" label="Back"
              (onClick)="_shellService.goBack()"></fpx-button>
            <fpx-button className="home" btnType="button" label="Home" (onClick)="_shellService.goHome()"></fpx-button>
        </ng-container>
        <ng-template #normalApp>
            <box class="header-inner">
                <h1 class="logo"><span>Bank</span></h1>
            </box>
        </ng-template>
    </header>
    <div class="clearfix content">
        <div class="clearfix bi-reponsive">
            <div class="clearfix logout-container" style="background:#F4F7F5;position: fixed;top: 0;right: 0;left: 0;bottom: 0;">
                <div class="clearfix logout-content request  report-filter">
                    <br>
                    <div>
                        <div class="er-404">
                            <!-- <img src="./assets/images/logo.svg" alt="page not found" class="erLogo"> -->
                            <img src="./assets/images/sbc/page-not-found.svg" alt="Error 404" class="erImg">
                            <p class="pagenotfound">{{'PAGENOTFOUND.Oooops' | translate}}</p>
                            <p class="sentral smallText">{{'PAGENOTFOUND.pageError' | translate}}</p>
                            <button [ngClass]="this._processShellService.getApplicationMode() == 'RM' ? 'btn-primary1' : 'link'"  
                            *ngIf="!http.loggedIn"  clickable (click)="gotoDashboard()">{{'PAGENOTFOUND.returnHomePage' | translate}}</button>
                            <!-- <button class="btn-primary" *ngIf="!http.loggedIn && "  clickable (click)="gotoDashboard()">{{'PAGENOTFOUND.returnHomePage' | translate}}</button> -->
                            <p class="sentral bigText">{{'PAGENOTFOUND.pageDesc' | translate}}</p>
                        </div>
                    </div>
    
                </div>
            </div>
        </div>
        <!--  <app-footer></app-footer>-->
    </div>
</box>